import { selectFromCustomerProfileDto } from '../../models';

export const CreateCustomerProfileMutation =
  selectFromCustomerProfileDto()
    .id
    .name
    .email
    .phone
    .notes
    .duration
    .isPriority
    .load
    .createdDate
    .updatedDate
    .metadata
    .tags
    .location(location => location
      .address
      .latitude
      .longitude
      .locationStatusId
      .active)
    .timeWindows(tw => tw
      .startTime
      .endTime)
    .toString();
